<template>
  <v-card
    max-width="480px"
    class="mx-auto px-5 py-2 my-5"
    justify="center"
    align="center"
  >
    <h2>Contact Us</h2>
    <v-card-subtitle></v-card-subtitle>
    <v-form
      action="https://getsimpleform.com/messages?form_api_token=898113378923113913950b189da80b8d"
      method="post"
    >
      <input
        type="hidden"
        name="redirect_to"
        value="https://robinlange.me/contact/success"
      />
      <v-text-field
        label="Name"
        v-model="name"
        :rules="[rules.required]"
        name="Name"
        type="text"
        outlined
      ></v-text-field>
      <v-text-field
        label="Email"
        v-model="email"
        :rules="[rules.required, rules.email]"
        name="Email"
        type="text"
        outlined
      ></v-text-field>
      <v-textarea
        label="Message"
        v-model="message"
        :rules="[rules.required, rules.counter]"
        counter="500"
        name="message"
        type="text"
        auto-grow
        outlined
      ></v-textarea>
      <vue-recaptcha
        sitekey="6LdZ8AAVAAAAAM1bTX9Rxwzzb9ggx0EGIaf0d3cV"
        :loadRecaptchaScript="true"
        @verify="onVerify"
        @expired="onExpired"
      >
      </vue-recaptcha>
      <v-btn type="submit" class="my-1" :disabled="captchaPassed" text>
        Submit
      </v-btn>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: "ContactForm",
  components: {
    VueRecaptcha: () => import("vue-recaptcha"),
  },
  data: () => ({
    captchaPassed: true,
    rules: {
      required: (value) => !!value || "This field is required",
      counter: (value) =>
        value.length <= 500 ||
        "Please keep your message to 500 characters or less",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail address";
      },
    },
  }),
  methods: {
    onVerify() {
      this.captchaPassed = false;
    },
    onExpired() {
      this.captchaPassed = true;
    },
  },
};
</script>

<style></style>
